import React from 'react';
import { Tag } from 'antd';
import { Influencer } from '../../../../services/marketingAPI';

export const AIAnalysisCell: React.FC<{ record: Influencer }> = ({ record }) => {
    if (!record.latest_analysis) return <span style={{ color: '#ccc' }}>未分析</span>;
    const { brand_fit_score, commercial_value, growth_potential } = record.latest_analysis;

    return (
        <div style={{ fontSize: '12px' }}>
            <div style={{ marginBottom: 4 }}>
                品牌契合: <Tag color={brand_fit_score >= 80 ? 'green' : brand_fit_score >= 60 ? 'orange' : 'red'}>{brand_fit_score}分</Tag>
            </div>
            <div style={{ marginBottom: 4 }}>
                商业价值: <span style={{ fontWeight: 500 }}>{commercial_value || '-'}</span>
            </div>
            <div>
                增长潜力: <span style={{ fontWeight: 500 }}>{growth_potential || '-'}</span>
            </div>
        </div>
    );
};

export const CategoryTagsCell: React.FC<{ record: Influencer }> = ({ record }) => (
    <div>
        <div style={{ marginBottom: 6 }}>
            <Tag color="geekblue">{record.category || '未分类'}</Tag>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {(record.tags || []).slice(0, 3).map(tag => (
                <Tag key={tag} style={{ fontSize: '10px', margin: 0 }}>{tag}</Tag>
            ))}
            {(record.tags || []).length > 3 && <span style={{ fontSize: '10px', color: '#999' }}>+{record.tags.length - 3}</span>}
        </div>
    </div>
);

export const CollaborationStatsCell: React.FC<{ record: Influencer }> = ({ record }) => (
    <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '16px', fontWeight: 'bold', color: record.collaboration_count > 0 ? '#1890ff' : '#999' }}>
            {record.collaboration_count}
        </div>
        <div style={{ fontSize: '10px', color: '#888' }}>合作次数</div>
    </div>
);

export const StatusCell: React.FC<{ status: string }> = ({ status }) => {
    let color = 'default';
    let label = status;
    switch (status) {
        case 'new': color = 'blue'; label = '新建'; break;
        case 'contacted': color = 'orange'; label = '已联系'; break;
        case 'cooperating': color = 'green'; label = '合作中'; break;
        case 'pending': color = 'gold'; label = '待处理'; break;
        case 'rejected': color = 'red'; label = '已拒绝'; break;
    }
    return <Tag color={color}>{label}</Tag>;
};
